var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target, mod));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// lib/main.jsx
var main_exports = {};
__export(main_exports, {
  default: () => main_default
});
module.exports = __toCommonJS(main_exports);
var import_react = __toESM(require("react"));
var import_sourceflowform = __toESM(require("@sourceflow-uk/sourceflowform"));
function SourceFlowApplicationForm({ jobId, formUrl, onSubmit, onSubmitDone, onSubmitError }) {
  const formUrlVal = formUrl || `/_sf/api/v1/jobs/${jobId}/apply`;
  if (typeof onSubmitDone !== "function") {
    return /* @__PURE__ */ import_react.default.createElement("span", null, "You must provide an onSubmitDone handler to provide feedback to the user");
  }
  return /* @__PURE__ */ import_react.default.createElement(import_sourceflowform.default, {
    formId: jobId,
    formUrl: formUrlVal,
    onSubmit,
    onSubmitDone,
    onSubmitError
  });
}
var main_default = SourceFlowApplicationForm;
